
import React from 'react';
import { Link } from 'react-router-dom';

const MobileTools: React.FC = () => {
  return (
    <section>
      <h2 className="text-2xl font-bold text-itmgmt-dark-blue mb-6">Mobile Technology for the Modern Agent</h2>
      
      <p className="mb-4 text-gray-700 leading-relaxed">
        Real estate professionals spend much of their time away from the office, making mobile solutions 
        critical to maintaining productivity and responsiveness:
      </p>
      
      <div className="mb-8">
        <h3 className="text-xl font-semibold text-itmgmt-medium-blue mb-4">1. Mobile-First Applications</h3>
        <p className="mb-4 text-gray-700 leading-relaxed">
          Key mobile technologies that empower agents in the field include:
        </p>
        <ul className="list-disc pl-6 mb-4 space-y-2 text-gray-700">
          <li className="leading-relaxed">
            Mobile CRM apps with offline access capabilities to client data
          </li>
          <li className="leading-relaxed">
            Property showing and feedback apps that streamline the showing process
          </li>
          <li className="leading-relaxed">
            Mobile document scanning for quick digitization of paperwork
          </li>
          <li className="leading-relaxed">
            Location-based MLS search tools for impromptu client demonstrations
          </li>
          <li className="leading-relaxed">
            Social media management apps for on-the-go marketing
          </li>
        </ul>
        <p className="text-gray-700 leading-relaxed">
          These mobile solutions rely on dependable <Link to="/services/cloud-solutions" className="text-itmgmt-bright-blue hover:underline">cloud infrastructure</Link> to function properly, making cloud migration and management a critical component of any real estate technology strategy.
        </p>
      </div>
      
      <div className="mb-8">
        <h3 className="text-xl font-semibold text-itmgmt-medium-blue mb-4">2. Cloud Communication Systems</h3>
        <p className="mb-4 text-gray-700 leading-relaxed">
          Effective agent-client communication requires comprehensive mobile-friendly systems:
        </p>
        <ul className="list-disc pl-6 mb-4 space-y-2 text-gray-700">
          <li className="leading-relaxed">
            Unified communication platforms that integrate calls, texts, and emails
          </li>
          <li className="leading-relaxed">
            Video conferencing tools for remote client meetings and property tours
          </li>
          <li className="leading-relaxed">
            Call forwarding and voicemail-to-email services
          </li>
          <li className="leading-relaxed">
            Team messaging platforms for internal collaboration
          </li>
          <li className="leading-relaxed">
            Automated notification systems for new listings, client inquiries, and important updates
          </li>
        </ul>
        <p className="text-gray-700 leading-relaxed">
          Solutions like RingCentral, Zoom for Real Estate, and Slack offer robust communication tools 
          that can be customized to real estate workflows. Ensuring these systems are properly configured and maintained is where <Link to="/services/managed-it-services" className="text-itmgmt-bright-blue hover:underline">managed IT services</Link> provide significant value.
        </p>
      </div>
    </section>
  );
};

export default MobileTools;
